// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/RegionSwitch/styles.scss
// module id = 823
// module chunks = 0